// Note: querystring-helper will change all keys to lowercase so make sure they are here as well
const queryStrings = {
    FMG_PAGE: "fmgPage",
    START_TYPE: "start_type",
    ZIP_CODE: "zipcode",
    PROMO: "promo",
    ERROR: "error",
    TOKEN: "token",
    PAYERID: "payerid",
    SUBSCRIPTIONID: "subscriptionid",
    REFERRAL_SEQ_NUM: "referralseqnum",
    CARD_EXPIRATION_MONTH: "card_expirationmonth",
    CARD_EXPIRATION_YEAR: "card_expirationyear",
    CARD_TYPE: "sgcardtype",
    BILL_TO_POSTAL_CODE: "billto_postalcode",
    BILL_TO_FIRST_NAME: "billto_firstname",
    BILL_TO_LAST_NAME: "billto_lastname",
    REFERENCE_NUMBER: "req_reference_number",
    AUTH_CODE: "auth_code",
    TRANSACTION_ID: "transaction_id",
    TRANS_REFERENCE_NUMBER: "auth_trans_ref_no",
    LAST_FOUR: "last_four",
    DISPLAY_PIA_ALERT: "displayPiaAlert",
    PAGE_ERROR: "pageerror",
    REFERRAL_NUMBER: "rn",
    PARENT_ACCOUNT: "pa",
    CORRELATION_ID: "ci",
    VEHICLE_YEAR: "vehicleyear",
    VEHICLE_MAKE: "vehiclemake",
    VEHICLE_MODEL: "vehiclemodel",
    VEHICLE_STYLE: "vehiclestyle",
    VEHICLE_DAMAGE: "vehicledamage",
    SERVICE_ZIP: "servicezip",
    EMAIL: "email",
    IS_INSURANCE: "isinsurance",
    VIN_SELECTION: "vinselection",
    SERVICE_PACKAGE: "servicepackage",
    NUMBER_OF_CHIPS: "numberofchips",
    LOG: "log",
    UTM_SOURCE: "_source",
    UTM_MEDIUM: "_medium",
    UTM_CAMPAIGN: "_campaign",
    CJ_EVENT: "cjevent",
    CJUNCTION: "cjunction",
    ORGANIC: "organic",
    ORGANIC_SOCIAL: "organic_social",
    EXPERIMENTS: "experiments",
    FROM_HERITAGE: "fromheritage",
    PHONE_NUMBER: "phonenumber",
    OFFER_QUOTE: "offerquote",
    PIA_AUTH_AMOUNT_ADJUST: "piaauthamountadjust",
    BAILOUT_CODE: "bailoutcode",
};

export { queryStrings };
